import { defineStore } from 'pinia'
import { loadScript, isScriptLoaded } from '@/utils/tools'
interface videoDetailState {
  videoId: string
  videoTitle: string
  vDetail: any
  likeIdList: string[] // 存储点赞视频的ID列表
  showRoutes: Boolean
  initVideo: Boolean
  playKeyValue: { key: string; value: string }
}
export const useVideoDetailStore = defineStore('videoDetailStore', {
  state: (): videoDetailState => {
    return {
      videoId: '',
      videoTitle: '',
      vDetail: {},
      likeIdList: [], // 初始化点赞ID列表
      showRoutes: false, //是否显示线路弹窗
      initVideo: false, //是否需要初始化播放器
      playKeyValue: {
        key: '1e8f26e4a5bd3c52be4a4b446adf3021',
        value: '4d3c2b1a78695f4e3d2c1b0fabcdef99'
      }
    }
  },
  getters: {
    // 是否点赞当前视频
    hasLike: (state) => {
      if (state?.likeIdList?.includes(state.videoId)) return true
      return false
    }
  },
  actions: {
    //加载插件
    async getPlugin() {
      return new Promise(async (resolve) => {
        //添加插件
        if (!isScriptLoaded('/js/video.min.js')) {
          const { currtAssertApi } = storeToRefs(useGlobalStore())
          const url = import.meta.env.DEV ? '' : currtAssertApi.value?.url || undefined
          await loadScript(url + '/js/video.min.js')
          await loadScript(url + '/js/video.eme.js')
          // await loadScript(url + "/videojs/videojs-contrib-quality-levels.min.js");
          await loadScript(url + '/js/videojs.ads.min.js')
          await loadScript(url + '/js/videojs-contrib-hlsjs.min.js')
          await loadScript(url + '/js/videojs-markers-vanilla.js')
        }
        resolve(true)
      })
    },
    //进度添加元素
    async addVideoMarker(instance: any) {
      const data =
        this.vDetail.videoChapterList?.map((item) => {
          return {
            text: item.title,
            time: item.start
          }
        }) || []
      try {
        instance.markers({
          markerStyle: {
            width: '8px',
            'z-index': 8,
            height: 'calc(100% + 4px)',
            'margin-top': '-2px',
            'background-color': '#fff',
            'border-radius': '9999px'
          },
          markers: data
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 添加点赞记录
    addLikeId(videoId: string) {
      if (!this.likeIdList.includes(videoId)) {
        this.likeIdList.push(videoId)
      }
    },
    // 移除点赞记录
    removeLikeId(videoId: string) {
      this.likeIdList = this.likeIdList.filter((id) => id !== videoId)
    },
    // 检查是否已点赞
    isVideoLiked(videoId: string): boolean {
      return this.likeIdList.includes(videoId)
    },
    // 清空点赞记录
    clearLikeIds() {
      this.likeIdList = []
    }
  },
  // 开始数据持久化
  persist: process.client && {
    key: 'videoDetailStore',
    storage: persistedState.localStorage,
    paths: ['videoId', 'videoTitle', 'likeIdList', 'playKeyValue'] // 确保持久化主题状态和点赞列表
  }
})
